module.exports = __webpack_public_path__ + "img/Fond_lampion_boule_papier.dd0a3d6.jpg";